export default __webpack_public_path__ + "static/media/YritysHyvä.b7ccf959.png";